// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".silence-title[data-v-1213e9a6] {\n  font-size: 1.875rem;\n}", ""]);
// Exports
module.exports = exports;
